export function observeWindowResize(onResize: () => void) {
  window.addEventListener('resize', onResize, false);
}
